<div *ngIf="totalLines > 0 || emptyText">
  <h3 class="step-title">
    {{ "GLOBAL_TERMS.LINES.SELECTED_LINES" | translate }}
  </h3>
  <span [attr.data-cy]="'group-count-line-total'" *ngIf="totalLines > 0">
    {{
      "GLOBAL_TERMS.LINES.LINES_SELECTED" | translate: { number: totalLines }
    }}
  </span>
  <span
    *ngIf="totalLines === 0"
    nz-typography
    nzType="secondary"
    class="empty-text"
  >
    <i class="fa-l fal fa-info-circle"></i>
    <span>{{ emptyText }}</span>
  </span>
  <ng-container *ngFor="let status of lineStatusList">
    <span *ngIf="countLinesStatuses[status]" class="status-tag">
      {{ countLinesStatuses[status] }}
      <nz-tag [nzColor]="status | ViewComputer: 'VIEW_LINE_STATUS'">
        {{ "GLOBAL_TERMS.LINES.STATUS." + status | translate }}
      </nz-tag>
    </span>
  </ng-container>
</div>
